import { IContentControlVideoSource } from 'app/js/src/domain/content-control/i-content-control-video-source';
import { StudioAudioManager } from './studio-audio-manager';

export class StudioAudioManagerLive extends StudioAudioManager {

  protected setupAudioContextImpl(
    _audioCtx: AudioContext,
    _gain: GainNode,
    _videoContainer: HTMLDivElement,
    _availableTracks: { [lang: string]: MediaElementAudioSourceNode },
  ): void {
    // HLS handles audio tracks, no need to setup audio context
  }

  protected handleAudioOptionChangeImpl(
    _option: string,
    _availableTracks: { [lang: string]: MediaElementAudioSourceNode },
    _video: IContentControlVideoSource,
    _isVideoAudioTrack: boolean,
    _syncAudioFn: () => void,
  ): void {
    // HLS handles audio track switching, no-op for live
  }
}
